export const GET_SUBSCRIPTION_PLAN = 'GET_SUBSCRIPTION_PLAN'
export const GET_SUBSCRIPTION_PLAN_REQUEST = 'GET_SUBSCRIPTION_PLAN_REQUEST'
export const GET_SUBSCRIPTION_PLAN_SUCCESS = 'GET_SUBSCRIPTION_PLAN_SUCCESS'
export const GET_SUBSCRIPTION_PLAN_ERROR = 'GET_SUBSCRIPTION_PLAN_ERROR'

export const UPDATE_SUBSCRIPTION_PLAN = 'UPDATE_SUBSCRIPTION_PLAN'

export const RESET_SUBSCRIPTION_PLAN = 'RESET_SUBSCRIPTION_PLAN'
